<template>
    <section class="card">
        <span v-for="(p, idx) in parts" :key="idx">
            <tr-text v-bind="p"  :tracker="tracker" @edit-tr="$emit('edit-tr', $event)" />
        </span>
    </section>
</template>

<script>
import TrText from "@/components/translation/TrText"

export default {
    name:     "I18nLogicCommand",
    components: {TrText},
    props: {
        tracker: Array,
        index: Number,
        parts: Array,
    }
}
</script>

<style>
</style>